import * as React from 'react'
import { Button, Form, Spinner } from 'react-bootstrap'
import { copyObject } from '../../utils';
import { UserT } from '../../types/Users';
import { asyncUserData } from '../../redux/actions';

import config from '../../constants/config';
import ButtonLoading from '../../components/ButtonLoading/ButtonLoading';
import { AxiosInstance } from '../../utils/RequestMethods';

const colors = {
    red: "#cc0000",
    green: "#198c19",
}
interface PasswordProps {
    // refreshUser(user: UserT): void
    // user: UserT
}

const Password: React.FunctionComponent<PasswordProps> = ({ }): JSX.Element => {
    const [validated, setValidated] = React.useState(false);
    const [result, setResult] = React.useState({
        loading: false,
        msg: '',
        isSuccess: false,
        showMsg: false,
    });
    const [fields, setFields] = React.useState({
        old_password: "",
        password: "",
        confirm_password: ""
    });
    const form = React.useRef(null)



    const changePasswordCurrentUser = async (params = {}): Promise<UserT> => {
        try {
            let res = await AxiosInstance.post(`${config.url.wpJson}/wp/v2/users/me/change_password`, params)
            if (res && res.data) {
                return res.data
            }
        } catch (error) {
            throw new Error(error)
        }
    }


    // const handleSubmit = async (event): Promise<string> => {
    //     event.preventDefault();

    //     if (!checkValidity()) {
    //         event.preventDefault();
    //         event.stopPropagation();
    //         setValidated(true)
    //         // return false;
    //         throw new Error("Required Information")
    //     }

    //     setValidated(true)
    //     await save(event);
    // }


    const checkValidity = () => {
        let valid = (fields.password != "" && fields.confirm_password != "") && (fields.password == fields.confirm_password)
        if (form) {
            let validityForm = form.current.checkValidity();
            return (validityForm && valid)
        }
        return false
    }

    const save = async (event): Promise<string> => {
        event.preventDefault();
        if (!checkValidity()) {
            event.preventDefault();
            event.stopPropagation();
            setValidated(true)
            // return false;
            throw new Error("Required fields")
        }
        // setResult({
        //     loading: true,
        //     msg: '',
        //     isSuccess: false,
        //     showMsg: false,
        // })
        let params = { ...fields }

        try {
            let res = await changePasswordCurrentUser(params)
            console.log("res", res)
            if (res) {
                //    refreshUser(res)
                let resUpdate = await asyncUserData()
                // setResult({ loading: false, msg: 'Password saved successfully.', showMsg: true, isSuccess: true, })
                setValidated(false)
                setTimeout(() => {
                    clearResult()
                    setFields({
                        old_password: '',
                        password: '',
                        confirm_password: '',
                    })
                }, 500);
                return 'Password saved.'
            }
        } catch (error) {

            // setResult({ loading: false, msg: "" + error.message, showMsg: true, isSuccess: false, })
            // setTimeout(() => {
            //     clearResult()
            // }, 1000);
            throw new Error(error)

        }
    }

    const clearResult = () => {
        setResult({ loading: false, msg: '', showMsg: false, isSuccess: false, })
    }

    const updateFields = (key: string, value: any): void => {
        let cloneFields = copyObject(fields)
        cloneFields[key] = value
        setFields(cloneFields)
    }

    return (
        <div>
            <Form
                // onSubmit={handleSubmit}
                noValidate
                ref={form}
                validated={validated}>
                <Form.Group>
                    <Form.Label>Old Password</Form.Label>
                    <Form.Control
                        type='password'
                        value={`${fields.old_password}`}
                        className='input-material'
                        onChange={(e) => {
                            updateFields('old_password', e.target.value)
                        }}
                        required={true}

                    />
                    <Form.Control.Feedback type="invalid">
                        Required.
                    </Form.Control.Feedback>
                </Form.Group>
                <Form.Group>
                    <Form.Label>New Password</Form.Label>
                    <Form.Control
                        type='password'
                        pattern="(?=^.{8,}$)((?=.*\d)|(?=.*\W+))(?![.\n])(?=.*[A-Z])(?=.*[a-z]).*$"
                        value={`${fields.password}`}
                        className='input-material'
                        onChange={(e) => {
                            updateFields('password', e.target.value)
                        }}
                        title="Must contain at least one number and one uppercase and lowercase letter, and at least 8 or more characters"
                        required={true}
                    />
                    <Form.Control.Feedback type="invalid">
                        {fields.password == "" ? `Required.` : 'Must contain at least one number and one uppercase and lowercase letter, and at least 8 or more characters'}
                    </Form.Control.Feedback>
                </Form.Group>
                <Form.Group>
                    <Form.Label>Re-enter New Password</Form.Label>
                    <Form.Control
                        pattern="(?=^.{8,}$)((?=.*\d)|(?=.*\W+))(?![.\n])(?=.*[A-Z])(?=.*[a-z]).*$"
                        type='password'
                        value={`${fields.confirm_password}`}
                        className='input-material'
                        onChange={(e) => {
                            updateFields('confirm_password', e.target.value)
                        }}
                        required={true}
                    />
                    <Form.Control.Feedback type="invalid">
                        {fields.confirm_password == "" ? `Required.` : 'Must contain at least one number and one uppercase and lowercase letter, and at least 8 or more characters'}
                    </Form.Control.Feedback>
                    <Form.Text className="" style={{ color: "#cc0000" }}>
                        {((fields.password != "" && fields.confirm_password != "") && (fields.password != fields.confirm_password)) && "The passwords do not match."}
                    </Form.Text>
                </Form.Group>


                {/* {result.loading && <>   <Spinner animation="border" /> Loading... </>}
                {result.showMsg && <span className="text-center" style={{ flex: 1, padding: 5, alignContent: 'center', justifyContent: 'center', alignItems: 'center' }}>
                    <span style={{ color: result.isSuccess ? colors.green : colors.red }} >{result.msg}</span>
                </span>} */}
                <ButtonLoading
                    type="submit"
                    className="btn-primary"
                    variant="success"
                    onClickFetching={async (e): Promise<string> => {
                        return await save(e)
                    }}
                >
                    Save
                </ButtonLoading>
            </Form>

        </div>
    )
}

export default Password
